import { Reveal } from "./Reveal";

const NOTES = [
  {
    quote: "Warm aesthetics combined with zero hassle during on-site carpentry. The team made our 3BHK feel authentic to our roots.",
    role: "Recent Homeowner",
    project: "3BHK Residential Renovation",
    testId: "testimonial-card-1",
  },
  {
    quote: "End-to-end execution meant we didn't have to chase five different vendors. The custom cane furniture is our favorite detail.",
    role: "Boutique Cafe Owner",
    project: "Commercial Space Fitout",
    testId: "testimonial-card-2",
  },
  {
    quote: "Transparent budgeting and thoughtful lighting layouts. They listened carefully to how we live before drawing anything.",
    role: "Villa Client",
    project: "Complete Turnkey Villa",
    testId: "testimonial-card-3",
  },
];

export const Testimonials = () => (
  <section id="reviews" className="py-24 px-6 md:px-10 bg-[#F4EDE2]" data-testid="testimonials-section">
    <div className="max-w-7xl mx-auto space-y-12">
      <Reveal className="max-w-2xl space-y-3">
        <span className="text-xs uppercase tracking-widest text-[#c88c2a] font-semibold">Client Notes</span>
        <h2 className="font-display text-3xl sm:text-4xl text-[#0D2121]">Stories of Built Homes</h2>
        <p className="text-[#7A6F66] text-sm">We take pride in transparent handovers and lasting relationships with homeowners and business owners.</p>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {NOTES.map((note, i) => (
          <Reveal key={note.role} delay={i * 100}>
            <div className="bg-[#FAF6F0] p-8 border border-[#0D2121]/10 flex flex-col justify-between space-y-6 h-full" data-testid={note.testId}>
              <div className="space-y-4">
                <div className="text-[#E2A435] font-display text-3xl leading-none">&ldquo;</div>
                <p className="text-[#7A6F66] text-sm italic leading-relaxed">{note.quote}</p>
              </div>
              <div className="pt-4 border-t border-[#0D2121]/10">
                <div className="font-semibold text-xs text-[#0D2121]">{note.role}</div>
                <div className="text-[11px] text-[#7A6F66]">{note.project}</div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
